import { Hour, Minute } from "@constants/time";

const InactivityTimeout = Hour * 4;
const InactivityPromptTimeout = Minute * 10;

export { InactivityTimeout, InactivityPromptTimeout };
